// this file is generated by update_shopify_store_data.py at 2026-02-23 20:29:33.801711
var courses = [];